import { Button } from "@/components/ui/button";
import { History } from "lucide-react";

interface HistoryButtonProps {
  onClick: () => void;
}

export const HistoryButton = ({ onClick }: HistoryButtonProps) => (
  <Button variant="ghost" size="icon" onClick={onClick}>
    <History className="h-4 w-4" />
  </Button>
);